import type { Routes } from '../../shares/types';
import { DetailsBasic } from './basic';

export const DETAILS_ROUTES: Routes = {
	details: {
		basic: DetailsBasic,
	},
};
